/**
 * Bigens T25 (T17a P1): the country list ships once per page.
 *
 * The header renders the country picker twice: the desktop dropdown and the mobile menu drawer. Each copy
 * holds every market country (237 rows, ~670 KB of HTML together), and Horizon refetches the header section
 * on every page view to hydrate it. The drawer copy is now rendered without its rows
 * (`bigens_defer_countries` in snippets/localization-form.liquid) and gets them from the dropdown copy the
 * first time the shopper opens the drawer's region picker. Their container carries `data-skip-subtree-update`, so
 * the header hydration morph leaves the copied rows alone.
 *
 * The dropdown copy is always in the DOM when the drawer copy is (same `show_country` condition in
 * sections/header.liquid; it's only hidden on mobile with CSS). The copied rows keep their `ref` and
 * `on:click` attributes, so LocalizationFormComponent picks them up through its MutationObserver.
 */

const DEFERRED = 'localization-form-component[data-bigens-defer-countries]';
const SOURCE = 'localization-form-component:not([data-bigens-defer-countries])';
const LISTS = ['.popular-countries', '.countries'];

/** @param {Element} target */
function fillCountries(target) {
  // Check for rows, not a flag attribute: header hydration morphs the drawer and would strip a flag.
  if (target.querySelector('li.localization-form__list-item')) return;

  const source = document.querySelector(SOURCE);
  if (!source) return;

  for (const selector of LISTS) {
    const from = source.querySelector(selector);
    const to = target.querySelector(selector);
    if (!from || !to) continue;

    const fragment = document.createDocumentFragment();
    for (const item of from.querySelectorAll(':scope > li.localization-form__list-item')) {
      const copy = /** @type {HTMLElement} */ (item.cloneNode(true));
      // The dropdown may be mid-filter or have a keyboard-highlighted row; the copy starts clean.
      copy.removeAttribute('hidden');
      copy.removeAttribute('aria-selected');
      fragment.append(copy);
    }
    to.append(fragment);
  }
}

/** @param {Event} event */
function onIntent(event) {
  if (!(event.target instanceof Element)) return;
  const drawer = event.target.closest('drawer-localization-component');
  if (!drawer) return;
  for (const form of drawer.querySelectorAll(DEFERRED)) fillCountries(form);
}

// Capture phase, so the rows exist before the drawer opens and focuses the filter input.
// `click` covers mouse, touch and Enter/Space on the <summary>.
document.addEventListener('pointerdown', onIntent, { capture: true });
document.addEventListener('click', onIntent, { capture: true });
